var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.25,
    height: 30.25,
    viewBox: "0 0 30.25 30.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_71",
    "data-name": "Trac\\xE9 71",
    d: "M31.25,17.125A14.125,14.125,0,1,1,17.125,3,14.125,14.125,0,0,1,31.25,17.125Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_72",
    "data-name": "Trac\\xE9 72",
    d: "M18,23.65V18",
    transform: "translate(-3.875 -3.875)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_73",
    "data-name": "Trac\\xE9 73",
    d: "M18,12h0",
    transform: "translate(-3.875 -3.525)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d07df7f999d5598a9166cd5a5ab2afaf.svg";
export { ForwardRef as ReactComponent };